import React from "react";
import Navbar from "../../components/Homepage/Navbar/Navbar";
import Footer from "../../components/Homepage/Footer/Footer";
import CampusMap from "../../components/Homepage/CampusLife/colleges/CampusMap";
import "./Contact.css";
import { useState } from "react";

const Contact = () => {
   const [selectedBuilding, setSelectedBuilding] = useState(null);
    const [view, setView] = useState("gallery"); // gallery | map
  const campusBuildings = [
  {
    id: 1,
    title: "Administrative Building",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3839.5929575106898!2d78.05602937936784!3d15.772657910284199!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb5e75ed738eda1%3A0xda1f1d653af5539e!2sRayalaseema%20University!5e0!3m2!1sen!2sin!4v1768894085462!5m2!1sen!2sin" ,

    images: ["/campuslife/college/ad-building.JPG"],
    description:
      "The Administrative Building serves as the central governance and decision-making hub of Rayalaseema University. It houses the Vice-Chancellor Office, Rector Office, Registrar Office, Examination Section, Establishment Section, Research Department, Academic Affairs Section, College Development Cell (CDC), Distance Education Section, Engineering Section, Electronic Section, and Finance Section."
  },
  {
    id: 2,
    title: "College of Engineering Building",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3839.5490798776837!2d78.05850774049756!3d15.77497583079942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb5ddbd1863aed7%3A0x3f3e4150c0234a2b!2sRayalaseema%20University%20College%20of%20Engineering!5e0!3m2!1sen!2sin!4v1768894261783!5m2!1sen!2sin" ,
    images: ["/campuslife/college/engineering-building.JPG"],
    description:
      "The College of Engineering Building accommodates the departments of Computer Science & Engineering, Artificial Intelligence, Electronics & Communication Engineering, Civil Engineering, and Mechanical Engineering along with the Engineering College Principal Office."
  },
  {
    id: 3,
    title: "Life Sciences Building",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3839.5490798776837!2d78.05850774049756!3d15.77497583079942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb5ddbd1863aed7%3A0x3f3e4150c0234a2b!2sRayalaseema%20University%20College%20of%20Engineering!5e0!3m2!1sen!2sin!4v1768894373742!5m2!1sen!2sin" ,
    images: ["/campuslife/college/lifesciencebuilding.JPG"],
    description:
      "The Life Sciences Building houses the departments of Botany, Zoology, Biotechnology, Food Science, and associated research laboratories supporting teaching and research in biological sciences."
  },
  {
    id: 4,
    title: "Academic Block – I",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3839.53363826615!2d78.05737316608429!3d15.775791484724456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb5dc543632fdcf%3A0x581153c37c4bb34c!2sAcademic%20Block.2!5e0!3m2!1sen!2sin!4v1768894750364!5m2!1sen!2sin" ,
    images: ["/campuslife/college/ab-1.JPG"],
    description:
      "Academic Block–I accommodates the departments of Physics and Chemistry along with the University College Principal Office, supporting fundamental science education and laboratory-based learning."
  },
  {
    id: 5,
    title: "Academic Block – II",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15358.134530582707!2d78.06187860645892!3d15.775791781600544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb5dc543632fdcf%3A0x581153c37c4bb34c!2sAcademic%20Block.2!5e0!3m2!1sen!2sin!4v1768894891683!5m2!1sen!2sin",
    images: ["/campuslife/college/ab-2.JPG"],
    description:
      "Academic Block–II houses the departments of Computer Science, Mathematics, and Statistics with smart classrooms, computer laboratories, and faculty offices."
  },
  {
    id: 6,
    title: "Academic Block – III",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3839.54609242218!2d78.06026896214904!3d15.77513363682369!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1srayalaseema%20university%20ad%20building!5e0!3m2!1sen!2sin!4v1768894670563!5m2!1sen!2sin" ,
    images: ["/campuslife/college/ab-3.JPG"],
    description:
      "Academic Block–III accommodates the departments of Telugu and English, supporting literary studies, language learning, and humanities research."
  },
  {
    id: 7,
    title: "Academic Block – IV",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3839.5490798776837!2d78.05850774049756!3d15.77497583079942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb5dc55c204d18d%3A0x2295b87ef6511254!2sAcadamic%20block%20lV!5e0!3m2!1sen!2sin!4v1768894429772!5m2!1sen!2sin",
    images: ["/campuslife/college/ab-4.JPG"],
    description:
      "Academic Block–IV houses the departments of Business Management (MBA), Commerce, and Economics, supporting management education and commerce studies."
  },
  {
    id: 8,
    title: "Library Building",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3839.521072517998!2d78.05845578885496!3d15.77645520000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb5ddbc7c882233%3A0x2bfd0b906411873b!2sOld%20Library!5e0!3m2!1sen!2sin!4v1768894513153!5m2!1sen!2sin",
    images: ["/campuslife/college/library-building.JPG"],
    description:
      "The Central Library Building provides access to textbooks, reference books, journals, e-resources, and digital databases supporting academic and research activities."
  },
  {
    id: 9,
    title: "Network & Data Centre",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3839.5371011104903!2d78.05887421346131!3d15.775608574581488!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb5dc55be5fc35f%3A0x24e1e01272b3dd79!2sQ3G7%2BFCQ%2C%20Kurnool%2C%20Banda%20Tandrapadu%2C%20Andhra%20Pradesh%20518007!5e0!3m2!1sen!2sin!4v1768894591604!5m2!1sen!2sin" ,
    images: ["/campuslife/college/network-center.JPG"],
    description:
      "The Network and Data Centre houses the university’s IT infrastructure, servers, networking systems, and digital platforms supporting online services and academic operations."
  }
];

  return (
    <>
      <Navbar />

      {/* ================= BANNER ================= */}
      <div className="contact-banner">
        <img src="/campuslife/college/ad-building.JPG" alt="Rayalaseema University" />
        <div className="contact-banner-overlay">
          <h1>Contact Us</h1>
          <p>Rayalaseema University, Kurnool</p>
        </div>
      </div>


{/* ================= CONTACT DETAILS ================= */}
<section className="contact-section">
  <div className="contact-container">

    <h2 className="contact-table-title">Contact Details</h2>

    <div className="contact-card">
      <h3>The Registrar</h3>

      <p>
        Rayalaseema University,<br />
        Kurnool. Pin: 518 007.<br />
        Andhra Pradesh, India.
      </p>

      <p>
        <strong>Phone:</strong>{" "}
        <a href="tel:9494410216">094944 10216</a>
      </p>

      <p>
        <strong>Email:</strong>{" "}
        <a href="mailto:registrarru@gmail.com">
          registrarru@gmail.com
        </a>
      </p>
    </div>

  </div>
</section>



     <section className="campus-map-section">
        <h2 className="campus-map-title">University Campus Map</h2>
        <p className="campus-map-subtitle">
          Explore campus buildings through photo galleries and location maps
        </p>

        {/* Building Cards */}
        <div className="campus-map-grid">
          {campusBuildings.map((building) => (
            <div key={building.id} className="campus-map-card">
              <h3>{building.title}</h3>
              <button
                className="campus-view-btn"
                onClick={() => {
                  setSelectedBuilding(building);
                  setView("gallery");
                }}
              >
                View
              </button>
            </div>
          ))}
        </div>

        {/* Modal */}
        {selectedBuilding && (
          <div className="campus-modal-overlay">
            <div className="campus-modal">
              <button
                className="campus-modal-close"
                onClick={() => setSelectedBuilding(null)}
              >
                ✕
              </button>

              <h3>{selectedBuilding.title}</h3>
              <p className="campus-modal-desc">
                {selectedBuilding.description}
              </p>

              {/* Tabs */}
              <div className="campus-modal-tabs">
                <button
                  className={view === "gallery" ? "active" : ""}
                  onClick={() => setView("gallery")}
                >
                  Gallery
                </button>
                <button
                  className={view === "map" ? "active" : ""}
                  onClick={() => setView("map")}
                >
                  Map
                </button>
              </div>

              {/* Gallery */}
              {view === "gallery" && (
                <div className="campus-modal-gallery">
                  {selectedBuilding.images.map((img, i) => (
                    <img key={i} src={img} alt={selectedBuilding.title} />
                  ))}
                </div>
              )}

              {/* Map */}
              {view === "map" && (
                <div className="campus-map-embed">
                  <iframe
                    src={selectedBuilding.mapEmbed}
                    loading="lazy"
                    allowFullScreen
                    referrerPolicy="no-referrer-when-downgrade"
                    title={`${selectedBuilding.title} Location`}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </section>


      <Footer />
    </>
  );
};

export default Contact;
